import React from 'react';
import { format } from 'date-fns';
import { ClientStatus } from '../types/client';
import { Badge } from '../styles/components';

export const formatDate = (dateString: string): string => {
  try {
    return format(new Date(dateString), 'MMM dd, yyyy');
  } catch {
    return 'Invalid date';
  }
};

export const formatDateTime = (dateString: string): string => {
  try {
    return format(new Date(dateString), 'MMM dd, yyyy h:mm a');
  } catch {
    return 'Invalid date';
  }
};

export const getStatusBadge = (status: ClientStatus | string): React.ReactElement => {
  const statusConfig = {
    Created: { variant: 'warning' as const, label: 'Created' },
    Active: { variant: 'success' as const, label: 'Active' },
    Locked: { variant: 'error' as const, label: 'Locked' },
    ActivationFailed: { variant: 'error' as const, label: 'Activation Failed' },
    Deleted: { variant: 'error' as const, label: 'Deleted' },
  };

  const config = statusConfig[status as ClientStatus] || { variant: 'info' as const, label: status };

  return (
    <Badge variant={config.variant}>
      {config.label}
    </Badge>
  );
};

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const formatClientId = (clientId: string): string => {
  // Format client ID for display (e.g., add spacing or formatting)
  return clientId;
};

export const getRelativeTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInHours < 168) return `${Math.floor(diffInHours / 24)}d ago`;
    return formatDate(dateString);
  } catch {
    return 'Unknown';
  }
}; 